import { Box2, Vector2 } from 'three';

export const box2FromSize = (width: number, length: number) =>
  new Box2(new Vector2(-width / 2, -length / 2), new Vector2(width / 2, length / 2));
